import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './BaseItemsList.scss';
import {Button} from 'components/controls';
import isScrolledIntoView from 'components/helpers/isScrolledIntoView';
import Spinner from './Spinner';

const FETCH_DELAY = 500;
export default class BaseItemsList extends PureComponent {
    static propTypes = {
        onGetItems: PropTypes.func.isRequired,
        onRenderItem: PropTypes.func,
        list: PropTypes.object,
        listPart: PropTypes.object,
        listProcessing: PropTypes.bool,
        itemsPerPage: PropTypes.number,
        placeholderText: PropTypes.string,
        fetchOnScroll: PropTypes.bool,
        scrollbarsId: PropTypes.string,
        params: PropTypes.object,
        entityId: PropTypes.string,
        listClassName: PropTypes.string,
        listComponentProps: PropTypes.object,
        placeholderClassName: PropTypes.string,
    };

    static defaultProps = {
        list: {},
        itemsPerPage: 5,
        placeholderText: loc('no-items-yet'),
        ListHeader: () => (<li />),
        params: {},
        entityId: null,
        listComponentProps: {},
        placeholderClassName: null,
    };

    state = {
        fetched: false,
    };

    timer = null;

    componentDidMount() {
        const {onGetItems, entityId, itemsPerPage, params} = this.props;
        if (onGetItems) {
            onGetItems(entityId, {offset: 0, limit: itemsPerPage, ...params, });
        }

        this.initScrollListener();
    }

    componentWillReceiveProps(next) {
        const {
            listProcessing,
            params,
            onGetItems,
            entityId,
            itemsPerPage,
        } = this.props;
        if (next.listProcessing)
            this.setState({fetched: false});
        if (!next.listProcessing && listProcessing) {
            this.setState({fetched: true});
        }
        if (!_.isEqual(next.params, params) && !listProcessing) {
            if (this.timer) {
                clearTimeout(this.timer);
            }
            this.timer = setTimeout(() => onGetItems(entityId, {offset: 0, limit: itemsPerPage, ...next.params, }), FETCH_DELAY);
        }
        const nextListLength = _.get(next, 'list.list.length', 0);
        const currentListLength = _.get(this.props, 'list.list.length', 0);
        const count = _.get(next, 'list.count', 0);

        const isLastElementDeleted = nextListLength === 0 && currentListLength === 1 && count > 1;
        if (isLastElementDeleted && !next.listProcessing) {
            onGetItems(entityId, {offset: 0, limit: itemsPerPage, ...next.params, });
        }
    };

    updateData = async () => {
        const {onGetItems, entityId, itemsPerPage, params} = this.props;
        await onGetItems(entityId, {offset: 0, limit: itemsPerPage, ...params, });
    }

    componentWillUnmount() {
        this.removeScrollListener();
    }

    timer = null;

    initScrollListener() {
        const {scrollbarsId} = this.props;

        if (scrollbarsId) {
            document.querySelector(`#${scrollbarsId} div:first-child`).onscroll = this.handleScroll;
        }
    }

    removeScrollListener() {
        const {scrollbarsId} = this.props;
        clearTimeout(this.timer);
        if (scrollbarsId) {
            document.querySelector(`#${scrollbarsId} div:first-child`).onscroll = null;
        }
    }

    isCanLoadMore() {
        const {
            list
        } = this.props;

        const {
            totalCount
        } = list;

        return list.list.length < totalCount;
    }

    handleLoadMore = () => {
        const {
            list,
            listPart,
            onGetItems,
            entityId,
            params,
        } = this.props;
        const isAlreadyLoading = !listPart;

        if (isAlreadyLoading)
            return;

        const {offset, limit} = list;

        if (!this.isCanLoadMore())
            return;

        onGetItems(entityId, {
            offset: offset + limit,
            limit,
            ...params
        });
    };

    handleScroll = () => {
        const {listProcessing} = this.props;

        if (listProcessing || !this.isCanLoadMore()) {
            return;
        }

        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            if (isScrolledIntoView(this.refs.loadMore)) {
                this.handleLoadMore();
            }
        }, 100);
    };

    render() {
        const {
            list,
            onRenderItem,
            placeholderText,
            ListHeader,
            listProcessing,
            listClassName,
            fetchOnScroll,
            ListComponent,
            className,
            preventPlaceholder,
            placeholderClassName,
            listComponentProps,
        } = this.props;

        const {fetched} = this.state;

        if (!list.list && !listProcessing) {
            return null;
        }

        if (list.totalCount === 0 && fetched) {
            if (preventPlaceholder) {
                return null;
            }

            return (
                <div className={classnames(
                    styles.noFound,
                    placeholderClassName,
                )}>
                    {placeholderText}
                </div>
            );
        }

        return (
            <ul className={classnames(styles.list, className)} ref='list'>
                {!listProcessing && <ListHeader />}
                <div className={listClassName}>
                    {ListComponent
                        ? <ListComponent list={list.list} {...listComponentProps} />
                        : list.list.map(onRenderItem)}
                </div>
                {this.isCanLoadMore() && !fetchOnScroll && !listProcessing && (
                    <div className={styles.buttonGrid}>
                        <Button onClick={this.handleLoadMore}
                            disabled={listProcessing}
                            label={loc('load-more')} />
                    </div>
                )}
                {this.isCanLoadMore() && fetchOnScroll &&
                    <div
                        ref='loadMore'
                        className={styles.loadMore}
                    />
                }
                {listProcessing && !preventPlaceholder &&
                    <Spinner className={styles.spinner} />
                }
            </ul>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/controls/BaseItemsList.js